/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicAzureRecommendationsSync extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicAzureRecommendationsSync");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicAzureRecommendationsSync.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicAzureRecommendationsSync>): BackgroundJobPayloadForPeriodicAzureRecommendationsSync {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicAzureRecommendationsSync(), model);
        BackgroundJobPayloadForPeriodicAzureRecommendationsSync.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicAzureRecommendationsSync>): BackgroundJobPayloadForPeriodicAzureRecommendationsSync {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicAzureRecommendationsSync.newInstance(<BackgroundJobPayloadForPeriodicAzureRecommendationsSync> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicAzureRecommendationsSync) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicAzureRecommendationsSync.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicAzureRecommendationsSync): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicAzureRecommendationsSync.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
